// SocialLinks.js
import React from 'react';

const SocialLinks = ({ product }) => {
  return (
    <div className="h-[120px] ml-4 flex flex-row items-center justify-end ">
      <div className="mt-2 flex flex-row gap-[24px] items-center">
        {product && product.facebook && (
          <a
            href={product.facebook}
            target="_blank"
            rel="noreferrer"
            className="w-9 h-9 xl:w-12 xl:w-12"
          >
            <img src={"https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/SocialMediaIcons/fb.png"} alt={`Meta Logo`} className="object-cover" />
          </a>
        )}

        {product && product.instagram && (
          <a
            href={product.instagram}
            target="_blank"
            rel="noreferrer"
            className="w-9 h-9 xl:w-12 xl:w-12"
          >
            <img src={"https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/SocialMediaIcons/IG.png"} alt={`Instagram Logo`} className="object-cover" />
          </a>
        )}

        {product && product.linkedin && (
          <a
            href={product.linkedin}
            target="_blank"
            rel="noreferrer"
            className="w-9 h-9 xl:w-12 xl:w-12"
          >
            <img src={"https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/SocialMediaIcons/LI.png"} alt={`Instagram Logo`} className="object-cover" />
          </a>
        )}

        {product && product.twitter && (
          <a
            href={product.twitter}
            target="_blank"
            rel="noreferrer"
            className="w-[34px] h-[34px] xl:w-[46px] xl:w-[46px]"
          >
            <img src={"https://charmhealth-marketplace-assets.s3.us-east-1.amazonaws.com/SocialMediaIcons/x.png"} alt={`Instagram Logo`} className="object-cover" />
          </a>
        )}
      </div>
    </div>
  );
};

export default SocialLinks;